import react, { useEffect, useState } from "react";
import { colors, fonts } from "../../Styles";

// #region | ToggleStyles
/* eslint-disable no-unused-vars */
export enum ToggleStyles {
  tableToggle = "tableToggle",
  greyTertiary = "greyTertiary",
  greySecondary = "greySecondary",
  blueDarkSecondary = "blueDarkSecondary"
}
/* eslint-enable no-unused-vars */

const createToggleStyle = (checkStyle?: ToggleStyles | string, focus_view?:boolean ) => {
  let colorStyle = ""
  let height = ""
  let width = ""
  let circleSize = ""
  let textColor = ""

  switch (checkStyle) {
    case ToggleStyles.tableToggle:
      colorStyle = colors.greyTertiary
      height = "25px"
      width = "43px"
      circleSize = "20px"
      textColor = colors.greyDarkPrimary
      break
    
    case ToggleStyles.greyTertiary:
      colorStyle = colors.greyTertiary
      height = "30px"
      width = "50px"
      circleSize = "23px"
      textColor = colors.greyDarkPrimary
    break
    
    case ToggleStyles.blueDarkSecondary:
      colorStyle = colors.blueDarkSecondary
      height = "30px"
      width = "50px"
      circleSize = "23px"
      textColor = colors.greyLightTertiary
    break
  
    case ToggleStyles.greySecondary:
    default:
      colorStyle = colors.greySecondary
      height = "30px"
      width = "50px"
      circleSize = "23px"
      textColor = colors.greyLightTertiary
    break
  }

  return {colorStyle, height, width, circleSize, textColor}
}
// #endregion

interface ToggleBox_Props {
  text?: string
  isChecked?: boolean
  disabled?: boolean
  onChange: (e:boolean) => void;
  icon: JSX.Element
  toggleStyles?: ToggleStyles
}

export default function ToggleBox({ text, onChange, disabled, isChecked, icon, toggleStyles=ToggleStyles.greySecondary }:ToggleBox_Props) {
  const [checked, setChecked] = useState(isChecked || false);
  const { colorStyle, height, width, circleSize, textColor } = createToggleStyle(toggleStyles);


  useEffect(() => {
    setChecked(isChecked || false);
  }, [isChecked]);

  const handleClick = () => {
    const newChecked = !checked;
    setChecked(newChecked);
    onChange(newChecked); 
  };

  const _root = text
  ? { display: "flex", flexDirection: "row" as const, alignItems: "center", justifyContent: "start", gap: "10px", width: "fit-content"}
  : undefined

  return (
    <div style={{..._root }}> 
      <div onClick={handleClick} style={{
        position: "relative",
        width: width,
        minWidth: width,
        height: height,
        backgroundColor: checked ? colors.systemGreen : colorStyle,
        borderRadius: "15px",
        cursor: disabled ? 'cursor' : 'pointer',
        pointerEvents: disabled ? 'none' : 'auto',
        boxSizing: "border-box"
      }}>
        <div style={{ 
          boxSizing: "border-box", 
          display: "flex", 
          alignItems: "center", 
          justifyContent: "center", 
          zIndex: "5", 
          transition: "0.5s ease-in-out",
          position: "absolute", 
          top: "50%", 
          left: "0%", 
          transform: checked ? "translate(100%, -50%) rotate(1deg)" : "translate(15%, -50%) rotate(-179deg)", 
          width: circleSize, 
          height: circleSize, 
          borderRadius: "15px", 
          backgroundColor: colors.greyDarkSecondary, 
        }}>
          {icon}
        </div>

      </div>
      <p style={{...fonts.header, color: textColor, ...fonts.fontSize4, cursor: 'cursor'}}>{text}</p>
    </div>
  );
}